import React from "react";
import { Form, Col, Card } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import Swal from "sweetalert2";

import FormActions from "../../../components/FormActions";
import { AppInput } from "../../../../../partials/form";
import { withFormValidation } from "../../../../../hoc";
import { CategoryApiService } from "../../../../../services/Ananse/CategoryApiService";
import FormHelper from "../../../../../helpers/FormHelper";
import { toAbsoluteUrl } from "../../../../../../_metronic";

const initialState = {
  name: "",
  codAmostra: "",
  chemicalName: "",
  casNumber: "",
  appearance: "",
  appearance_en: "",
  appearance_es: "",
  fragrance: "",
  fragrance_en: "",
  fragrance_es: "",
  flavor: "",
  flavor_en: "",
  flavor_es: "",
  food: "",
  kosher: false,
  halal: false,
  isO9001: false,
  options: [],
  callToAction: "",
  callToAction_en: "",
  callToAction_es: "",
  currentUploadedSecret: null
};

class CategoryForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ...initialState
    };

    this.api = new CategoryApiService();
    this.handleChange = this.props.handleChange.bind(this);
    this.onCleanForm = this.props.onCleanForm.bind(this);

    this.formHelper = new FormHelper(this);
  }

  componentDidMount() {
    this.formHelper.loadFromService();

    try {
      const options = [
        {
          key: true,
          // name: this.props.translate.family.tryIt
          name: "Sim"
        },
        {
          key: false,
          // name: this.props.translate.family.release
          name: "Não"
        }
      ];

      this.setState({ options });
    } catch (error) {
      Swal.fire(
        this.props.translate.defaultMessages.error,
        this.props.translate.defaultMessages.loadData,
        "error"
      );
    }
  }

  mapModelToState(model) {
    return {
      name: model.name,
      codAmostra: model.codAmostra,
      chemicalName: model.chemicalName,
      casNumber: model.casNumber,
      appearance: model.appearance,
      appearance_en: model.appearance_en,
      appearance_es: model.appearance_es,
      fragrance: model.fragrance,
      fragrance_en: model.fragrance_en,
      fragrance_es: model.fragrance_es,
      flavor: model.flavor,
      flavor_en: model.flavor_en,
      flavor_es: model.flavor_es,
      food: model.food,
      kosher: model.kosher,
      halal: model.halal,
      isO9001: model.isO9001,
      callToAction: model.callToAction,
      callToAction_en: model.callToAction_en,
      callToAction_es: model.callToAction_es
    };
  }

  mapStateToModel() {
    return {
      name: this.state.name,
      codAmostra: this.state.codAmostra,
      chemicalName: this.state.chemicalName,
      casNumber: this.state.casNumber,
      appearance: this.state.appearance,
      appearance_en: this.state.appearance_en,
      appearance_es: this.state.appearance_es,
      fragrance: this.state.fragrance,
      fragrance_en: this.state.fragrance_en,
      fragrance_es: this.state.fragrance_es,
      flavor: this.state.flavor,
      flavor_en: this.state.flavor_en,
      flavor_es: this.state.flavor_es,
      food: this.state.food,
      kosher: this.state.kosher,
      halal: this.state.halal,
      isO9001: this.state.isO9001,
      callToAction: this.state.callToAction,
      callToAction_en: this.state.callToAction_en,
      callToAction_es: this.state.callToAction_es
    };
  }

  render() {
    if (this.props.match.params.id) {
      window.setPageTitle(
        `${this.props.translate.screens.category.pageTitle.edit} - Admin`
      );
    } else {
      window.setPageTitle(
        `${this.props.translate.screens.category.pageTitle.create} - Admin`
      );
    }

    const {
      name,
      codAmostra,
      chemicalName,
      casNumber,
      appearance,
      appearance_en,
      appearance_es,
      fragrance,
      fragrance_en,
      fragrance_es,
      flavor,
      flavor_en,
      flavor_es,
      food,
      kosher,
      halal,
      isO9001,
      options,
      callToAction,
      callToAction_en,
      callToAction_es
    } = this.state;

    return (
      <Card className="mt-3">
        <Card.Header>
          {this.props.translate.screens.category.mainData}
        </Card.Header>
        <Card.Body>
          <Form onSubmit={this.formHelper.submit}>
            <Form.Row>
              <Form.Group as={Col} lg="8" xs="12">
                <Form.Label>{this.props.translate.family.title} *</Form.Label>
                <AppInput
                  type="text"
                  name="name"
                  placeholder={this.props.translate.family.title}
                  maxLength="100"
                  value={name}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"required|min:3|max:100"}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  {this.props.translate.family.codSample} *
                </Form.Label>
                <AppInput
                  type="text"
                  name="codAmostra"
                  placeholder={this.props.translate.family.codSample}
                  maxLength="100"
                  value={codAmostra}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img
                    src={toAbsoluteUrl("/media/flags/255-brazil.svg")}
                    alt=""
                    width="20px"
                    height="20px"
                  />
                  {" "}
                  Call To Action
                </Form.Label>
                <AppInput
                  type="text"
                  name="callToAction"
                  placeholder="Call To Action"
                  maxLength="255"
                  value={callToAction}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img src={toAbsoluteUrl("/media/flags/226-united-states.svg")} alt="" width="20px" height="20px" />
                  {" "}
                  Call To Action
                </Form.Label>
                <AppInput
                  type="text"
                  name="callToAction_en"
                  placeholder="Call To Action"
                  maxLength="255"
                  value={callToAction_en}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img src={toAbsoluteUrl("/media/flags/es.svg")} alt="" width="20px" height="20px" />
                  {" "}
                  Call To Action
                </Form.Label>
                <AppInput
                  type="text"
                  name="callToAction_es"
                  placeholder="Call To Action"
                  maxLength="255"
                  value={callToAction_es}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
            </Form.Row>

            {/* Ficha Técnica */}
            <Form.Label>{this.props.translate.family.dataSheet}</Form.Label>
            <Form.Row>
              <Form.Group as={Col} lg="8" xs="12">
                <Form.Label>
                  {this.props.translate.family.chemicalName}
                </Form.Label>
                <AppInput
                  type="text"
                  name="chemicalName"
                  placeholder={this.props.translate.family.casNumber}
                  maxLength="255"
                  value={chemicalName}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>{this.props.translate.family.casNumber}</Form.Label>
                <AppInput
                  type="text"
                  name="casNumber"
                  placeholder={this.props.translate.family.chemicalName}
                  maxLength="255"
                  value={casNumber}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img
                    src={toAbsoluteUrl("/media/flags/255-brazil.svg")}
                    alt=""
                    width="20px"
                    height="20px"
                  />
                  {" "}
                  {this.props.translate.family.appearance}
                </Form.Label>
                <AppInput
                  type="text"
                  name="appearance"
                  placeholder={this.props.translate.family.appearance}
                  maxLength="255"
                  value={appearance}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img src={toAbsoluteUrl("/media/flags/226-united-states.svg")} alt="" width="20px" height="20px" />
                  {" "}
                  {this.props.translate.family.appearance}
                </Form.Label>
                <AppInput
                  type="text"
                  name="appearance_en"
                  placeholder={this.props.translate.family.appearance}
                  maxLength="255"
                  value={appearance_en}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img src={toAbsoluteUrl("/media/flags/es.svg")} alt="" width="20px" height="20px" />
                  {" "}
                  {this.props.translate.family.appearance}
                </Form.Label>
                <AppInput
                  type="text"
                  name="appearance_es"
                  placeholder={this.props.translate.family.appearance}
                  maxLength="255"
                  value={appearance_es}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Form.Row>
            {/* Application */}
            <Form.Label>{this.props.translate.family.aplication}</Form.Label>

            <Form.Row>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img
                    src={toAbsoluteUrl("/media/flags/255-brazil.svg")}
                    alt=""
                    width="20px"
                    height="20px"
                  />
                  {" "}
                  {this.props.translate.family.fragrance}
                </Form.Label>
                <AppInput
                  type="text"
                  name="fragrance"
                  placeholder={this.props.translate.family.fragrance}
                  maxLength="255"
                  value={fragrance}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img src={toAbsoluteUrl("/media/flags/226-united-states.svg")} alt="" width="20px" height="20px" />
                  {" "}
                  {this.props.translate.family.fragrance}
                </Form.Label>
                <AppInput
                  type="text"
                  name="fragrance_en"
                  placeholder={this.props.translate.family.fragrance}
                  maxLength="255"
                  value={fragrance_en}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img src={toAbsoluteUrl("/media/flags/es.svg")} alt="" width="20px" height="20px" />
                  {" "}
                  {this.props.translate.family.fragrance}
                </Form.Label>
                <AppInput
                  type="text"
                  name="fragrance_es"
                  placeholder={this.props.translate.family.fragrance}
                  maxLength="255"
                  value={fragrance_es}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img
                    src={toAbsoluteUrl("/media/flags/255-brazil.svg")}
                    alt=""
                    width="20px"
                    height="20px"
                  />
                  {" "}
                  {this.props.translate.family.flavor}
                </Form.Label>
                <AppInput
                  type="text"
                  name="flavor"
                  placeholder={this.props.translate.family.flavor}
                  maxLength="255"
                  value={flavor}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img src={toAbsoluteUrl("/media/flags/226-united-states.svg")} alt="" width="20px" height="20px" />
                  {" "}
                  {this.props.translate.family.flavor}
                </Form.Label>
                <AppInput
                  type="text"
                  name="flavor_en"
                  placeholder={this.props.translate.family.flavor}
                  maxLength="255"
                  value={flavor_en}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
              <Form.Group as={Col} lg="4" xs="12">
                <Form.Label>
                  <img src={toAbsoluteUrl("/media/flags/es.svg")} alt="" width="20px" height="20px" />
                  {" "}
                  {this.props.translate.family.flavor}
                </Form.Label>
                <AppInput
                  type="text"
                  name="flavor_es"
                  placeholder={this.props.translate.family.flavor}
                  maxLength="255"
                  value={flavor_es}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>
            </Form.Row>

            {/* BASF Certification */}
            <Form.Label>{this.props.translate.family.certification}</Form.Label>
            <Form.Row>
              <Form.Group as={Col} lg="3" xs="12">
                <Form.Label>{this.props.translate.family.food}</Form.Label>
                <AppInput
                  type="text"
                  name="food"
                  placeholder={this.props.translate.family.food}
                  maxLength="255"
                  value={food}
                  onChange={this.handleChange}
                  validator={this.props.validator}
                  validations={"max:255"}
                />
              </Form.Group>

              <Form.Group as={Col} lg="1" xs="12">
                <Form.Label>{this.props.translate.family.kosher} *</Form.Label>
                <Form.Control
                  name="kosher"
                  value={kosher}
                  validations={"required"}
                  validator={this.props.validator}
                  translate={this.props.translate}
                  onChange={this.handleChange}
                  as="select"
                >
                  <option value="">Selecione</option>
                  {options.map(p => (
                    <option key={p.key} value={p.key}>
                      {p.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} lg="1" xs="12">
                <Form.Label>{this.props.translate.family.halal} *</Form.Label>
                <Form.Control
                  name="halal"
                  value={halal}
                  validations={"required"}
                  validator={this.props.validator}
                  translate={this.props.translate}
                  onChange={this.handleChange}
                  as="select"
                >
                  <option value="">Selecione</option>
                  {options.map(p => (
                    <option key={p.key} value={p.key}>
                      {p.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} lg="1" xs="12">
                <Form.Label>{this.props.translate.family.iso} *</Form.Label>
                <Form.Control
                  name="isO9001"
                  value={isO9001}
                  validations={"required"}
                  validator={this.props.validator}
                  translate={this.props.translate}
                  onChange={this.handleChange}
                  as="select"
                >
                  <option value="">Selecione</option>
                  {options.map(p => (
                    <option key={p.key} value={p.key}>
                      {p.name}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Form.Row>

            <FormActions
              module="categories"
              formIsValid={true}
              onCleanForm={this.onCleanForm}
            />
          </Form>
        </Card.Body>
      </Card>
    );
  }
}

export default withRouter(withFormValidation(CategoryForm, initialState));
